export default __webpack_public_path__ + "static/media/portada_KatiaKolovea.f96d872a.jpg";